import { Component, OnInit } from '@angular/core';
import { Button4Component } from '../button4/button4.component';
// import { SelectModule } from 'primeng/select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommanService } from '../../_services/comman.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { Input1Component } from '../input1/input1.component';
import { Button5Component } from '../button5/button5.component';
import { ExportDataService } from '../../_services/export-data.service';
import { Button6Component } from '../button6/button6.component';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { DropdownModule } from 'primeng/dropdown';
import { DatasearchService } from '../../_services/datasearch.service';
import { AuthenticationService } from '../../_services/authentication.service';
import { user_privilege } from '../../../_model/user_privilege';
import { ConstantService } from '../../_services/constant.service';
import { BusyService } from '../../_services/busy.service';
@Component({
  selector: 'app-listview-gridview-header',
  standalone: true,
  imports: [
    CommonModule,
    Button4Component,
    FormsModule,
    // SelectModule,
    DialogModule,
    ButtonModule,
    Input1Component,
    Button5Component,
    Button6Component,
    TableModule,
    InputNumberModule,
    DropdownModule,
  ],
  templateUrl: './listview-gridview-header.component.html',
  styleUrl: './listview-gridview-header.component.scss',
})
export class ListviewGridviewHeaderComponent implements OnInit {
  // Current view type variable Ex. listView | gridView
  currViewType!: string;
  searched: boolean = false;
  // Columns setting dialog
  isShowColumnsSettingDialog: boolean = false;
  currResultTotal: any;
  // Current columns
  currColumns: any[] = [];
  cols: any[] = [];
  rptDataForExcel: any = [];
  currCriteria: any[] = [];
  currPagenumber: number = 1;
  currRowsCount: number = 15;
  current_GBRN: any = 0;
  currFilters: any[] = [];
  currSelectedSubFilterCountry: string = '';
  currSelectedSubFilterCompany: string = '';
  currSortField: string = '';
  currSortOrder: string = '';
  user_data: any;
  searchQueryGrid: string = '';
  privilege_json!: user_privilege;
  // Current result countries
  resultCountries: any[] = [];
  selectedSubFilterCountryObj!: { label: string; value: string };

  // Current result companies
  resultCompanies: any[] = [];
  currCountry: string = '';
  selectedSubFilterCompanyObj!: { label: string; value: string };

  constructor(
    private _commanService: CommanService,
    private datasearch: DatasearchService,
    private authentication: AuthenticationService,
    private _constant: ConstantService,
    private commanService: CommanService,
    private busyService: BusyService,
    private exportdataService: ExportDataService
  ) {}

  ngOnInit(): void {
    this.commanService.currentgbrn.subscribe((gbrn_res: any) => {
      if (gbrn_res) {
        this.current_GBRN = gbrn_res;
      }
    });

    this.commanService.getUserPrivilege().subscribe((res: any) => {
      // this.user_data = res;
      this.privilege_json = res || {};
    });

    // Get current columns

    this._commanService.getColumns().subscribe((res) => {
      this.currColumns = res;
      this.searched = true;
    });
    this.commanService.productInformationData.subscribe((res: any) => {
      const rawQuery = res.searchQueryGrid || '';
      this.searchQueryGrid = this.parseSearchQuery(rawQuery); // <-- returns a string
    });
    // Get current view type
    this._commanService.getViewType().subscribe((res) => {
      this.currViewType = res;
    });

    // Get current countries
    this._commanService.getResultCountries().subscribe((res) => {
      // console.log('getResultCountries', res);
      this.resultCountries = res;
    });

    // Get current companies
    this._commanService.getResultCompanies().subscribe((res) => {
      // console.log('getResultCompanies', res);

      this.resultCompanies = res;
    });

    this._commanService.getResultTotal().subscribe((res) => {
      // console.log('getResultCompanies', res);

      this.currResultTotal = res;
    });
  }

  loadColumnDetails() {

    this.datasearch.getGapdColumns().subscribe(
      (res: any) => {
        res.data.results.forEach((field: any) => {
          field.columnWidth = parseInt(field.columnWidth.replace('px', ''));
        });
        this.currColumns = res.data.results;

        this._commanService.setColumns(this.currColumns);
      },
      (error: any) => {
        console.error('Error loading column details:', error);
      }
    );
  }

  exportExcel(extension: any) {
    // console.log('Export initiated with extension:', extension);

    let sortby: string = '';
    if (this.currSortField && this.currSortOrder) {
      sortby = this.currSortField + ' ' + this.currSortOrder;
    }

    let postdata = {
      gbrn: this.current_GBRN || '',
      country: this.currCountry,
      criteria: this.currCriteria,
      pagenumber: this.currPagenumber,
      rowscount: 1000,
      sortby: sortby,
      filters: this.currFilters,
      subFilters: {
        country: this.currSelectedSubFilterCountry,
        company: this.currSelectedSubFilterCompany,
      },
    };

    // console.log('Export postdata:', postdata);

    this.busyService.busy();
    this.datasearch.getplatforgapddata(postdata).subscribe(
      (response: any) => {
        const DownloadData = response.data.data || [];
        // console.log('Export data received:', DownloadData);

        // Use the loaded columns here, NOT this.cols
        let displayedColumns = this.currColumns
          .filter((col) => Number(col.isDisplay) === 1)
          .sort((a, b) => a.displayOrder - b.displayOrder);

        // Extract fields and headers
        let fields = displayedColumns.map((col) => col.field);
        let headers = displayedColumns.map((col) => col.header);

        // Prepare rows data before filtering columns and rows
        let allRowData: any[][] = [];

        DownloadData.forEach((row: any, index: number) => {
          row.S_NO = index + 1;

          const rowData = fields.map((field) => {
            if (row.gbrn_products?.length > 0) {
              const gbrnProduct = row.gbrn_products[0];
              if (gbrnProduct.hasOwnProperty(field)) {
                return gbrnProduct[field];
              }
            }
            return row[field];
          });

          allRowData.push(rowData);
        });

        // Remove columns with all empty values
        // Identify columns to keep (where at least one row has data)
        let colsToKeepIndexes: number[] = [];
        for (let colIndex = 0; colIndex < fields.length; colIndex++) {
          let hasData = allRowData.some((row) => {
            const val = row[colIndex];
            return val !== null && val !== undefined && val !== '';
          });
          if (hasData) {
            colsToKeepIndexes.push(colIndex);
          }
        }

        // Filter headers and fields to keep only columns with data
        headers = colsToKeepIndexes.map((i) => headers[i]);
        fields = colsToKeepIndexes.map((i) => fields[i]);

        // Filter row data to keep only columns with data
        let filteredRowData = allRowData.map((row) =>
          colsToKeepIndexes.map((i) => row[i])
        );

        // Remove rows which are all empty after filtering (except S_NO which is index 0 if exists)
        // Assume S_NO is always first column (index 0), so check from index 1 onwards
        filteredRowData = filteredRowData.filter((row) => {
          return row.some((val, idx) => {
            if (idx === 0) return true; // keep S_NO always
            return val !== null && val !== undefined && val !== '';
          });
        });

        this.rptDataForExcel = filteredRowData;

        // console.log(
        //   'Processed filtered data for export:',
        //   this.rptDataForExcel
        // );
        // console.log('Filtered headers:', headers);

        let reportData = {
          title: 'GAPD Data Report',
          data: this.rptDataForExcel,
          headers: headers,
          sheetname: 'data',
          file_extention: extension,
          searchterm: this.searchQueryGrid,
        };

        // console.log('Final reportData for export:', reportData);

        this.exportdataService.exportExcel(reportData);
      },
      (error: any) => {
        console.error('Export Error:', error);
      },
      () => {
        this.busyService.idle();
        // console.log('Export process completed.');
      }
    );
  }

  parseSearchQuery(query: string): string {
    const regex = /ACTIVE INGREDIENT:\(([^)]+)\)/gi;
    let matches: string[] = [];
    let match;

    while ((match = regex.exec(query)) !== null) {
      matches.push(match[1].toUpperCase()); // Convert each to uppercase
    }

    // Replace original condition logic (AND/OR/etc.) in the query
    let result = query;

    // Replace with placeholders to capture order
    let placeholderIndex = 0;
    result = result.replace(regex, () => `{{${placeholderIndex++}}}`);

    // Replace placeholders with capitalized matches
    matches.forEach((val, i) => {
      result = result.replace(`{{${i}}}`, val);
    });

    return result;
  }

  // Method for change view type
  toggleViewType(viewType: 'listView' | 'gridView') {
    this._commanService.setViewType(viewType);
  }

  // Method to show columns setting dialog
  showColumnsSettingDialog() {
    this.isShowColumnsSettingDialog = true;
  }

  sendSelectedSubFilterCounty() {
    if (this.selectedSubFilterCountryObj) {
      this._commanService.setSelectedSubFilterCountry(
        this.selectedSubFilterCountryObj.value === 'View All'
          ? ''
          : this.selectedSubFilterCountryObj.value
      );
    }
  }

  sendSelectedSubFilterCompany() {
    if (this.selectedSubFilterCompanyObj) {
      this._commanService.setSelectedSubFilterCompany(
        this.selectedSubFilterCompanyObj.value === 'View All'
          ? ''
          : this.selectedSubFilterCompanyObj.value
      );
    }
  }

  resetFilters() {
    this.selectedSubFilterCountryObj = {
      label: 'All Country',
      value: 'View All',
    };

    this.selectedSubFilterCompanyObj = {
      label: 'All Company',
      value: 'View All',
    };

    this.sendSelectedSubFilterCounty();
    this.sendSelectedSubFilterCompany();
  }
}
